// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"537":"a03f2823","1312":"af374c83","1418":"85641c18","2808":"f34e0124","3248":"af374c83","5668":"038d03f0","6513":"f94f0740","7569":"9b0cb96b","8245":"038d03f0"}[chunkId] + ".chunk.css";
};